import React from 'react';
// import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import styled from 'styled-components';
import Tippy from '@tippyjs/react';
import { Tooltip } from 'react-clone-tippy';
import { Badge } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { getTranslatedText } from '@nile/components';
import { FormattedMessage, injectIntl } from 'react-intl';

const CellWrapper = styled.div`
  display: inline-block;
  position: relative;
  width: 100%;
  max-width: 100%;
  .subject-container {
    max-width: ${(props) => (props.isUnknown ? 'calc(100% - 80px)' : '100%')};
  }
  .subject {
    height: auto !important;
  }
`;

const TimerNotesCell = (props) => {
  const { cell, intl } = props;

  return cell?.value ? (
    <CellWrapper className="flex center fg1">
      <Tippy
        content={
          <div className="p10 br10">
            <div className="subject">{cell?.value}</div>
          </div>
        }
        placement="right"
        arrow={false}
        interactive
        theme="light"
        trigger="mouseenter"
        allowHTML
        appendTo={document.body}
        maxWidth={500}
        zIndex={500}
        delay={500}
      >
        <div className="subject-container">
          <div className="subject ellipsis">{cell?.value}</div>
        </div>
      </Tippy>
    </CellWrapper>
  ) : (
    <Tooltip
      title={getTranslatedText(intl, 'timer.add.note.to.convert')}
      position="top-start"
      inertia
      className="full-width"
      trigger="mouseenter"
      animation="shift"
      animateFill={false}
    >
      <Badge
        size="large"
        icon={<SVGIcon name="WarningOutline" size="sm" />}
        iconPosition="left"
        status="attention"
      >
        <FormattedMessage id="timer.add.note.to.convert" />
      </Badge>
    </Tooltip>
  );
};

export default injectIntl(TimerNotesCell);
